import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useDispatch, useSelector } from 'react-redux';
import { selectDestinations, selectAccessToken } from '../../store/selectors';
import { getDestinations } from '../../store/actions';

interface IDestinationDropdownProperties {
  selectedValue: string[];
  onChange: (event: { value: string[] }) => void;
  allowedCodes?: string[];
}

const DestinationDropdown: React.FC<IDestinationDropdownProperties> = ({ selectedValue, onChange, allowedCodes }) => {
  const dispatch = useDispatch();
  const destinations = useSelector(selectDestinations);
  const accessToken = useSelector(selectAccessToken);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    if (destinations.length === 0 && accessToken) {
      dispatch(getDestinations());
    }
  }, [dispatch, accessToken]);

  useEffect(() => {
    if (destinations.length > 0) {
      const filteredDestinations =
        allowedCodes === undefined
          ? destinations
          : destinations.filter((destination) => allowedCodes.includes(destination.code));
      const sortedOptions = filteredDestinations
        .map((destination) => ({
          label: `${destination.code} - ${destination.name}`,
          value: destination.code,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setOptions(sortedOptions);
    }
  }, [destinations, allowedCodes]);

  return (
    <MultiSelect
      id="destinationDropdown"
      value={selectedValue}
      options={options}
      onChange={onChange}
      placeholder="Select Destinations"
      display="chip"
      filter
    />
  );
};

export default DestinationDropdown;
